import { useState } from "react";
import { PropTypes } from "prop-types";
import { API } from "aws-amplify";
import { Button, TextField } from "@mui/material";
import "./cohortForm.scss";
import { createCohort } from "../../graphql/mutations";

const propTypes = {
  setAlert: PropTypes.func.isRequired,
  updateCohortsStates: PropTypes.func.isRequired,
};

const CohortForm = ({ setAlert, updateCohortsStates }) => {
  const [name, setName] = useState("");
  const [year, setYear] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setAlert("");
      let returnedCohort = await API.graphql({
        query: createCohort,
        variables: { input: { name, year } },
      });
      returnedCohort = returnedCohort.data?.createCohort;
      if (returnedCohort) {
        updateCohortsStates(returnedCohort);
        setName("");
        setYear("");
      }
    } catch (error) {
      setAlert("Failed to save. Try again.");
    }
  };

  return (
    <form className="cohort-form" onSubmit={handleSubmit}>
      <TextField
        required
        className="name"
        label="Cohort Name"
        variant="standard"
        size="small"
        value={name}
        placeholder="Awesome Platoon"
        onChange={(e) => setName(e.target.value)}
      />
      <TextField
        required
        className="year"
        label="Graduation Year"
        variant="standard"
        size="small"
        value={year}
        placeholder="2022"
        onChange={(e) => setYear(e.target.value)}
      />
      <Button
        className="add-button"
        variant="contained"
        color="secondary"
        type="submit"
      >
        Add
      </Button>
    </form>
  );
};

CohortForm.propTypes = propTypes;

export default CohortForm;
